// Selectors
import { createSelector } from '@reduxjs/toolkit';
import { ApplicationState } from '../../store';


export const servicesSelector = (state: ApplicationState) => state.servicesState

export const servicesLoadingSelector = createSelector(servicesSelector, (state) => state.loading);
